<template>
  <div class="kpt-device-create">
    <vue-headful title="Create Device" />
    <header class="kpt-detail-pane-header">
      <h4>Create Device</h4>
      <div class="page-control">
        <font-awesome-icon :icon="['far', 'times-circle']" size="lg" @click="close" />
      </div>
    </header>
    <div class="kpt-create-steps">
      <p>Easily add devices to the system without having to dabble in SQL.</p>
      <br />
      <div class="kpt-field-container">
        <b-field label="Account" horizontal left>
          <b-select v-model="deviceToCreate.accountId" v-if="accounts.length > 1">
            <option
                v-for="option in accounts"
                :value="option.id"
                :key="option.id">
                {{ option.name }}
            </option>
          </b-select>
          <b-select v-model="deviceToCreate.accountId" v-else>
            <option :value="user.accountId">{{user.accountName}}</option>
          </b-select>
        </b-field>
      </div>
      <hr>
      <div class="kpt-field-container">
        <b-field label="Serial" horizontal required left>
          <b-input type="text" spellcheck="false" autocomplete="off" placeholder="e.g. AAE00019..." expanded v-model="deviceToCreate.serial"></b-input>
        </b-field>
      </div>
      <div class="kpt-field-container">
      <b-field label="Device Type" horizontal required left>
        <b-select v-model="deviceToCreate.deviceTypeId" expanded>
          <option
              v-for="option in deviceTypes"
              :value="option.id"
              :key="option.id">
              {{ option.name }}
          </option>
        </b-select>
      </b-field>
      </div>
      <div class="kpt-field-container">
        <b-field label="Device Model" horizontal required left>
          <b-select :disabled="deviceToCreate.deviceTypeId == null" v-model="deviceToCreate.deviceModelId" expanded>
            <option
                v-for="option in getModelsForType(deviceToCreate.deviceTypeId)"
                :value="option.id"
                :key="option.id">
                {{ option.name }}
            </option>
          </b-select>
        </b-field>
      </div>
    </div>
    <footer class="kpt-create-navigation">
      <div class="buttons">
        <b-button size="is-small" type="is-primary" @click="create" :disabled="creating" :loading="creating">Create Device</b-button>
      </div>
    </footer>
  </div>
</template>
<script>
import { orderBy } from 'lodash';
import { idToNameParserMixin } from '../../shared/mixins/idToNameParser';

export default {
  data() {
    return {
      deviceToCreate: {
        serial: null,
        accountId: null,
        deviceTypeId: null,
        deviceModelId: null
      },
      creating: false
    }
  },
  mixins: [idToNameParserMixin],
  methods: {
    close() {
      this.$router.push({ path: '/devices' });
    },
    async create() {
      this.creating = true;
      const result = await this.$store.dispatch('addDevice', this.deviceToCreate);
      this.creating = false;
      if (result && !result.success) {
        this.$buefy.toast.open({
          duration: 3000,
          message: result.message,
          type: 'is-danger'
        });
        return;
      }
      this.$router.push({ name: 'deviceOverview', params: { id: this.$store.state.devices.device.id } });
    },
    getModelsForType(type) {
      const deviceTypeId = this.deviceTypes.find(t => t.id == type);
      if (deviceTypeId) {
        return this.deviceModels.filter(m => m.deviceTypeId == deviceTypeId.id);
      }
      return [];
    },
    modelIsRequired(property) {
      // eslint-disable-next-line no-void
      return property != null && property != '' && property != undefined && property != void 0;
    },
    getAccountName(id) {
      const account = this.accounts.find(a => a.id == id);
      return account ? account.name : '-';
    }
  },
  mounted() {
    this.deviceToCreate.accountId = this.user.accountId;
  },
  computed: {
    user() { return this.$store.state.user.user },
    accounts() { return orderBy(this.$store.state.accounts.accounts, ['name'], ['asc']); },
    deviceTypes() { return this.$store.state.devices.types.filter(d => (d.shortcode == 'DEV_ANTNA' || d.shortcode == 'DEV_TRMNL')) },
    deviceModels() { return this.$store.state.devices.models }
  },
  watch: {
    // eslint-disable-next-line quote-props, no-unused-vars
    'activeStep': function (newValue, oldValue) {
      if (newValue == 2) {
        this.validate();
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.kpt-device-create {
  height: 100%;
  display: flex;
  flex-direction: column;

  .kpt-create-steps {
    padding: 12px;
    flex: 1 1 auto;
    overflow-y: auto;
  }

  .kpt-field-container {
    width: 100%;
    max-width: 400px;
    margin-bottom: 8px;

    @media screen and (min-width: 1441px) {
      width: 50%;
      max-width: 600px;
    }
  }
}

</style>
